import React, { useContext } from "react"
import { View } from "react-native"
import SelectBox from "@common/components/select/selectSingle-Multiple"
import IconButtonM from "@common/components/button/IconButtonM"
import TextButtonM from "@common/components/button/TextButtonM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"

/**
 * Reusable multi-stage selector with subject selection.
 * Used in NewSubscriptionScreen stepper and StagePaymentModal.
 *
 * @param {Array} holidayCourses - Selected courses: [{index, id, school_subject_ids}]
 * @param {Function} setHolidayCourses - State setter
 * @param {Array} holidayCourseOptions - Available courses: [{label, value}]
 * @param {Array} schoolSubjects - Available subjects: [{id, name, icon}]
 */
export const HolidayCourseSelector = ({
    holidayCourses,
    setHolidayCourses,
    holidayCourseOptions,
    schoolSubjects,
}) => {
    const dimensions = useContext(DimensionsContext)
    const selectWidth = Math.min((dimensions?.width ?? 400) / 2 - 50, 200)

    if (!holidayCourseOptions?.length) return null

    return (
        <View
            style={{
                padding: 10,
                borderRadius: 15,
                marginBottom: 10,
                backgroundColor:
                    holidayCourses?.length > 0
                        ? theme.colors.primaryLighter
                        : null,
            }}
        >
            {holidayCourses.length > 0 &&
                holidayCourses.map((course, idx) => (
                    <View
                        key={course.index}
                        style={{
                            marginTop: 10,
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 5,
                        }}
                    >
                        <SelectBox
                            title={"Stage"}
                            options={holidayCourseOptions}
                            valueMode
                            value={course.id}
                            onSingleSelect={(opt) => {
                                const list = [...holidayCourses]
                                list[idx] = { ...list[idx], id: opt.value }
                                setHolidayCourses(list)
                            }}
                            buttonStyle={{ height: 45 }}
                            style={{ width: selectWidth }}
                        />
                        <SelectBox
                            title={"Matières"}
                            isMulti
                            maxSelect={2}
                            options={schoolSubjects?.map((s) => ({
                                label: s.name,
                                value: s.id,
                                icon: s.icon,
                            }))}
                            valueMode
                            selectedValues={course.school_subject_ids ?? []}
                            onMultiSelect={(item) => {
                                const list = [...holidayCourses]
                                const ids = list[idx].school_subject_ids ?? []
                                if (ids.includes(item.value)) {
                                    list[idx].school_subject_ids = ids.filter(
                                        (id) => id !== item.value
                                    )
                                } else {
                                    list[idx].school_subject_ids = [
                                        ...ids,
                                        item.value,
                                    ]
                                }
                                setHolidayCourses(list)
                            }}
                            style={{ width: selectWidth }}
                        />
                        <IconButtonM
                            icon="trash"
                            iconColor={theme.colors.primary}
                            onPress={() =>
                                setHolidayCourses(
                                    holidayCourses.filter((_, i) => i !== idx)
                                )
                            }
                        />
                    </View>
                ))}
            <TextButtonM
                label={"+ Ajouter un stage de révision"}
                onPress={() =>
                    setHolidayCourses([
                        ...holidayCourses,
                        {
                            index: (holidayCourses?.length ?? 0) + 1,
                            id: holidayCourseOptions?.[0]?.value,
                            school_subject_ids: [],
                        },
                    ])
                }
                fontWeight="Bold"
                color={theme.colors.primary}
                style={{ alignSelf: "center", marginTop: 10 }}
            />
        </View>
    )
}
